module.exports = __webpack_public_path__ + "static/media/it-iq-logo.5f5e9315.jpg";